import { renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "list-comp flex flex-col items-center" }
const _hoisted_2 = {
  key: 0,
  class: "list-add-wrapper"
}
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListAdd = _resolveComponent("ListAdd")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ListAddLine = _resolveComponent("ListAddLine")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.add)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "add", {
            add: val => _ctx.$emit('add', {name: val, pos: 0}),
            index: 0
          })
        ], 512)), [
          [_vShow, !_ctx.hideTopAdd]
        ])
      : _withDirectives((_openBlock(), _createBlock(_component_ListAdd, {
          key: 1,
          onAdd: _cache[0] || (_cache[0] = val => _ctx.$emit('add', {name: val, pos: 0}))
        }, null, 512)), [
          [_vShow, !_ctx.hideTopAdd]
        ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 2 }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.items, (item, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            (_ctx.$slots.default)
              ? _renderSlot(_ctx.$slots, "default", {
                  key: 0,
                  item: item,
                  index: i,
                  onClick: ($event: any) => (_ctx.$emit('select', item))
                })
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "notebook bg-blue-500 p-1",
                  onClick: ($event: any) => (_ctx.$emit('select', item))
                }, _toDisplayString(item.name), 9, _hoisted_3)),
            (_ctx.addInPos)
              ? (_openBlock(), _createBlock(_component_ListAddLine, {
                  key: 2,
                  class: "w-full",
                  onAdd: val => _ctx.$emit('add', {name: val, pos: i + 1}),
                  index: i,
                  ref_for: true,
                  ref: 'addLine' + (i + 1)
                }, {
                  default: _withCtx(() => [
                    (_ctx.$slots.add)
                      ? _renderSlot(_ctx.$slots, "add", {
                          key: 0,
                          add: val => _ctx.addFromSlot(val, i + 1),
                          index: i
                        })
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["onAdd", "index"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
  ]))
}